export const LOAD_CART = "LOAD_CART";
export const ADD_CART = "ADD_CART";
export const REMOVE_CART = "REMOVE_CART";
export const DEC_CART = "DEC_CART";
export const INC_CART = "INC_CART";
export const UPDATE_CART_QUANTITY = "UPDATE_CART_QUANTITY";
export const EMPTY_CART = "EMPTY_CART";

export const emptyCart = () => {
  return async dispatch => {
    dispatch({ type: EMPTY_CART });
  };
};

export const updateCartQuantity = ({ id }, quantity) => {
  return async dispatch => {
    dispatch({ type: UPDATE_CART_QUANTITY, payload: { id, quantity } });
  };
};

export const incCart = ({ id }) => {
  return async dispatch => {
    dispatch({ type: INC_CART, payload: id });
  };
};
export const decCart = ({ id }) => {
  return async dispatch => {
    dispatch({ type: DEC_CART, payload: id });
  };
};

export const removeCart = ({ id }) => {
  return async dispatch => {
    dispatch({ type: REMOVE_CART, payload: id });
  };
};

export const loadCart = () => {
  return async dispatch => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    dispatch({ type: LOAD_CART, payload: cart });
  };
};

export const addCart = (product, quantity) => {
  return async dispatch => {
    dispatch({ type: ADD_CART, payload: { product, quantity } });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/cart.js